import React from 'react';
import Anchor from '../Anchor';
import { setDetailPageUrl } from '../../../lib/common';
import { EVENT_EDIT_URL_PATH } from '../../../constants/service/common/urlConstants';

type Props = {
  /** 링크로 보여줄 문구. 보통 `#4855` 같은 id 표기 */
  text: string;
  eventId: number | null;
};

/**
 * 기획전 상세(수정) 페이지로 여는 링크.
 *
 * admin 에는 기획전 전용 상세 화면이 따로 없고 수정 화면이 그 역할을 한다 — `/event/edit/:id`.
 * `OpenCouponDetail` 과 같은 결이되, 연결이 없을 수 있어 `eventId` 가 비면 아무것도 그리지 않는다.
 */
const OpenEventDetail = ({ text, eventId }: Props) => {
  if (eventId === null) {
    return null;
  }

  return (
    <Anchor
      text={text}
      isUnderLine
      color="primary"
      href={setDetailPageUrl(EVENT_EDIT_URL_PATH, eventId)}
      target="_blank"
    />
  );
};

export default OpenEventDetail;
